import { gql } from 'urql';

export const SECURITY_ROLES_QUERY = gql`
  query SecurityRoles($search: String, $active: Boolean) {
    security_roles(search: $search, active: $active) {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      esSistema
      userCount
      permisos {
        id
        code
        name
        module
        action
        criticality
      }
    }
  }
`;

export const SECURITY_ROLE_DETAIL_QUERY = gql`
  query SecurityRoleDetail($id: ID!) {
    security_role(id: $id) {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      esSistema
      userCount
      permisos {
        id
        code
        name
        description
        module
        group
        action
        criticality
        path
      }
    }
    security_catalog {
      generatedAt
      permissions {
        id
        code
        name
        description
        module
        group
        action
        criticality
        path
        active
      }
    }
  }
`;

export const SECURITY_ROLE_CREATE_QUERY = gql`
  query SecurityRoleCreate {
    security_catalog {
      generatedAt
      permissions {
        id
        code
        name
        description
        module
        group
        action
        criticality
        path
        active
      }
    }
  }
`;

export const SECURITY_ROLE_SAVE_MUTATION = gql`
  mutation SecurityRoleSave($input: SecurityRoleInput!) {
    security_role_save(input: $input) {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      userCount
      permisos {
        id
        code
        name
        module
        action
        criticality
      }
    }
  }
`;

export const SECURITY_ROLE_CLONE_MUTATION = gql`
  mutation SecurityRoleClone($id: ID!, $input: SecurityRoleCloneInput!) {
    security_role_clone(id: $id, input: $input) {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      userCount
    }
  }
`;

export const SECURITY_ROLE_TOGGLE_MUTATION = gql`
  mutation SecurityRoleToggle($id: ID!, $active: Boolean!) {
    security_role_toggle(id: $id, active: $active) {
      id
      activo
    }
  }
`;

export const SECURITY_ROLE_DELETE_MUTATION = gql`
  mutation SecurityRoleDelete($id: ID!) {
    security_role_delete(id: $id)
  }
`;
